import {ISlidePreview} from '../../incase-domain/proptypes/slidePreview';
import {IHideLoadingSpinnerAction, IShowLoadingSpinnerAction, IUpdateSelectedSlidePreviewsAction} from './types/slide.preview.types';

export const UPDATE_SELECTED_SLIDE_PREVIEWS = 'UPDATE_SELECTED_SLIDE_PREVIEWS';
export const SHOW_LOADING_SPINNER = 'SHOW_LOADING_SPINNER';
export const HIDE_LOADING_SPINNER = 'HIDE_LOADING_SPINNER';

export const updateSelectedSlidePreviewsAction = (slidePreviews: ISlidePreview[]): IUpdateSelectedSlidePreviewsAction => ({
    type: UPDATE_SELECTED_SLIDE_PREVIEWS,
    payload: slidePreviews,
});

export const showLoadingSpinnerAction = (): IShowLoadingSpinnerAction => ({
    type: SHOW_LOADING_SPINNER,
});

export const hideLoadingSpinnerAction = (): IHideLoadingSpinnerAction => ({
    type: HIDE_LOADING_SPINNER,
});
